exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "p{color:#4a4a4a;font-family:Source Sans Pro,sourcesanspro-regular,regular,Arial,sans-serif;font-size:16px;font-weight:400;line-height:1.5;margin:0 0 20px}", ""]);

